module.exports = __webpack_public_path__ + "img/Logo_Banco_Mundial.370c0717.png";